export const STATE_NAME = 'payoutsMultiBilling';

// TODO: refactor
// eslint-disable-next-line prefer-regex-literals
export const REMOVE_COMMA_REGEX = new RegExp(/(,)(.)$/);
